import React from 'react'
import LoadingPage from 'views/LoadingPage'

export default function LoadableLoading({
  isLoading
}) {
  return isLoading && <LoadingPage />
}
